import { Item } from "@radix-ui/react-dropdown-menu";
import React from "react";

import { cn } from "@/styles/cn";

export const DropdownMenuItem = React.forwardRef<
  React.ElementRef<typeof Item>,
  React.ComponentPropsWithoutRef<typeof Item> & {
    inset?: boolean;
  }
>(({ className, inset, ...props }, ref) => (
  <Item
    ref={ref}
    className={cn(
      "relative flex cursor-default select-none items-center px-4 py-1.5 text-[0.75rem] text-urbix-gray-1000 outline-none transition-colors focus:bg-urbix-gray-200 focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      inset && "pl-8",
      className,
    )}
    {...props}
  />
));
DropdownMenuItem.displayName = Item.displayName;
